import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ReduxRootStateType } from '../redux/store';

function ProtectedRoute() {
  const user = useSelector((state: ReduxRootStateType) => state.user);

  return user.is_logged_in ? <Outlet /> : <Navigate to="/login" />;
}

export default ProtectedRoute;
